import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { AppComponent } from './app/app.component';
import { mainRoutes } from './main.routes';
import { provideLottieOptions } from 'ngx-lottie';
import { importProvidersFrom } from '@angular/core';
import { HttpService } from './app/services/http.service';
import { HttpClientModule } from '@angular/common/http';


bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(HttpService),
    importProvidersFrom(HttpClientModule),
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(mainRoutes, withPreloading(PreloadAllModules)),
  ],
});
